import {Component, Input, OnInit} from '@angular/core';
import {BaseModalComponent} from "../modal/base-modal.component";
import {ConfirmationDialogOptions} from "./confirmation-dialog.service";

@Component({
  selector: 'mes-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent extends BaseModalComponent implements OnInit {

  @Input() public question: string;
  @Input() public description: string;
  isYesDisabled: boolean = true;
  @Input() public options: ConfirmationDialogOptions;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.options = Object.assign({showNo: true, showYes: true, yesLabel: 'Yes', noLabel: 'No', hasSafetyCheck: false}, this.options);
  }

  public onConfirm(): void {
    this.close(true);
  }

  public onCancel(): void {
    this.close(false);
  }

  public hideConfirmationModal(): void {
    this.close(null);
  }
}
